import { render } from "./ourProperties.vue?vue&type=template&id=78167486&scoped=true"
import script from "./ourProperties.vue?vue&type=script&lang=js"
export * from "./ourProperties.vue?vue&type=script&lang=js"

import "./ourProperties.vue?vue&type=style&index=0&id=78167486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78167486"]])

export default __exports__